/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { LocationWrapper } from './LocationWrapper'
import {
  LocationWrapperFromJSON,
  LocationWrapperFromJSONTyped,
  LocationWrapperToJSON,
} from './LocationWrapper'

/**
 *
 * @export
 * @interface EnvelopedLocationWrapperLocationPublic
 */
export interface EnvelopedLocationWrapperLocationPublic {
  /**
   *
   * @type {LocationWrapper}
   * @memberof EnvelopedLocationWrapperLocationPublic
   */
  body: LocationWrapper
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedLocationWrapperLocationPublic
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedLocationWrapperLocationPublic interface.
 */
export function instanceOfEnvelopedLocationWrapperLocationPublic(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedLocationWrapperLocationPublicFromJSON(
  json: any,
): EnvelopedLocationWrapperLocationPublic {
  return EnvelopedLocationWrapperLocationPublicFromJSONTyped(json, false)
}

export function EnvelopedLocationWrapperLocationPublicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedLocationWrapperLocationPublic {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: LocationWrapperFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedLocationWrapperLocationPublicToJSON(
  value?: EnvelopedLocationWrapperLocationPublic | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: LocationWrapperToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
